<div [formGroup]="form">
  <div class="row" *ngIf="loadLanes !== 1">
    <div class="form-group col-4" >
      <custom-select
        [filterEnabled]="true"
        [labelText]="'Eje'"
        [bordered]="true"
        name="vialAxis"
        id="vialAxis"
        (click)="_errorBackEnd = ''"
        formControlName="vialAxes"
        [(sourceList)]="_vialAxesList"
        required>
      </custom-select>
    </div>
    <div class="form-group col-4">
      <custom-select
        [filterEnabled]="true"
        [labelText]="'Calzada'"
        [bordered]="true"
        name="trafficDirections"
        id="trafficDirections"
        formControlName="trafficDirections"
        [(sourceList)]="_trafficDirectionsList"
        (select)="onSelectDirection()">
      </custom-select>
    </div>
    <div class="form-group col-4">
      <custom-select
        [filterEnabled]="true"
        [labelText]="'Vía'"
        [bordered]="true"
        name="laneRoadway"
        id="laneRoadway"
        (click)="_errorBackEnd = ''"
        formControlName="laneRoadway"
        [(sourceList)]="_laneRoadwayList"
        (select)="onSelectLane(laneRoadway?.value);">
      </custom-select>
    </div>
    <div class="form-group col-4">
      <custom-select
        [filterEnabled]="true"
        [labelText]="'Pista'"
        [bordered]="true"
        name="lane"
        id="lane"
        formControlName="lanes"
        [(sourceList)]="_laneList">
      </custom-select>
    </div>
    <div class="form-group col-4">
      <label for="startKilometerLane">PK Inicio</label>
      <input
        type="tel"
        formControlName="startKilometerLane"
        (click)="_laneErrorMessage = ''"
        class="form-control"
        id="startKilometerLane"
        name="startKilometerLane"
        lang="en"
        pattern="^([0-9.]+)"
        [customMax]="99999999"
        (paste)="_formValidatorService.validateOnlyNumberAndDot($event)"
        (keypress)="($event.charCode == 46 || ($event.charCode >= 48 && $event.charCode <= 57))"/>
    </div>
    <div class="form-group col-4">
      <label for="endKilometerLane">PK Fin</label>
      <input
        type="tel"
        formControlName="endKilometerLane"
        (click)="_laneErrorMessage = ''"
        class="form-control"
        id="endKilometerLane"
        name="endKilometerLane"
        lang="en"
        pattern="^([0-9.]+)"
        [customMax]="99999999"
        (paste)="_formValidatorService.validateOnlyNumberAndDot($event)"
        (keypress)="($event.charCode == 46 || ($event.charCode >= 48 && $event.charCode <= 57))"/>
    </div>
    <div class="form-group col-6">
      <lib-datepicker
      [labelText]="'Fecha y hora inicio'"
      name="dateFromLane"
      id="dateFromLane"
      [useTime]="true"
      [defaultToday]="true"
      [initCurrentTime]="!dateFromlanes?.value?.Date?.Day ? true : false"
      [disabledFutureDates]="true"
      formControlName="dateFromlanes"
      (openCalendar)="updateMaxDate()"
      (ngModelChange)="applyFilters('dateFromlanes')"
      [maxDate]="today"
      [required]="true"
      ></lib-datepicker>
    </div>
    <div class="form-group col-6">
      <lib-datepicker
      [labelText]="'Fecha y hora fin'"
      name="dateToLanes"
      id="dateToLanes"
      [defaultToday]="false"
      [disabledFutureDates]="true"
      [useTime]="true"
      [initCurrentTime]="!dateToLanes?.value?.Date?.Day ? true : false"
      formControlName="dateToLanes"
      [placeholder] ="'Fecha y hora fin'"
      (openCalendar)="updateMaxDate()"
      (ngModelChange)="applyFilters('dateToLanes')"
      [minDate]="minDateLane"
      [maxDate]="today"
      [required]="false"
      ></lib-datepicker>
    </div>
    <div class="form-group col-4">
      <label for="movil">Móvil
        <span class="ml-1" triggers="click hover" tooltip="Listado de vehiculos propios que realizan asistencias">
          <i class="fa fa-question-circle" style="color:var(--primary)"></i>
        </span>
      </label>
      <custom-select
        [filterEnabled]="true"
        [bordered]="true"
        name="movil"
        id="movil"
        formControlName="movil"
        [(sourceList)]="_movilList"
        required>
      </custom-select>
    </div>
    <div class="form-group col-4">
      <label for="reasonLaneClose" class="text-truncate mb-0" style="max-width: 100%;">Motivo de cierre</label>
      <custom-select
        [filterEnabled]="true"
        [bordered]="true"
        name="reasonLaneClose"
        id="reasonLaneClose"
        formControlName="reasonLaneClose"
        [(sourceList)]="_reasonLaneCloseList"
        >
      </custom-select>
    </div>
    <div class="form-group col-4" >
      <label for="reasonLaneOpen" class="text-truncate mb-0" style="max-width: 100%;">Motivo de apertura</label>
      <custom-select
        [filterEnabled]="true"
        [useParentWidth]="true"
        [bordered]="true"
        [isDisabled]="!dateToLanes?.value?.Date?.Day ?true:false"
        name="reasonLaneOpen"
        id="reasonLaneOpen"
        formControlName="reasonLaneOpen"
        [(sourceList)]="_reasonLaneOpenList"
        [required]="dateToLanes?.value?.Date?.Day ? true:false">
      </custom-select>
    </div>
  </div>
</div>

<div class="text-center my-3 not-found-data d-flex align-items-center justify-content-center" style="min-height: 450px;" *ngIf="loadLanes == 1">
  <i class="fas fa-circle-notch fa-spin fa-3x"></i>
</div>